import HideOnScroll from "components/HideOnScroll";

const ViewHeaderScrollCollapse = HideOnScroll;

export default ViewHeaderScrollCollapse;
